import { UseQueryResult, useQuery } from 'react-query';
import { getNpiInfo } from 'src/api/user';
export const npiInfoKey = 'npiInfo';

interface NpiInfo {
    npi: string;
    firstName: string;
    lastName: string;
    credential: string;
}

export const useNpiInfo = (npi: string): UseQueryResult<NpiInfo> => {
    return useQuery({
        queryKey: [npiInfoKey, npi],
        queryFn: async () => {
            return await getNpiInfo(npi);
        },
        enabled: false,
        initialData: null,
    });
};
